import { ErrorHandler, NgModule } from '@angular/core';

import { ApErrorHandlerService } from './error.handler';
import { ApErrorService } from './error.service';
import { ApErrorComponent } from './error.component';

/**
 * @name ApErrorModule
 * @ngdoc module
 */
@NgModule({
    imports: [ApErrorComponent],
    exports: [ApErrorComponent],
    providers: [
        ApErrorService,
        {
            provide: ErrorHandler,
            useClass: ApErrorHandlerService
        }
    ]
})
export class ApErrorModule {}
